import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea880ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "绑定手机", -1))
const _hoisted_3 = { class: "action" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认绑定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createBlock(_component_VanPopup, {
    show: _ctx.isShow,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShow) = $event)),
    style: {"border-radius":"4px"},
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_VanField, {
          placeholder: "请输入手机",
          border: false,
          modelValue: _ctx.data.mobile,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.mobile) = $event)),
          maxlength: "11",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_VanField, {
          placeholder: "请输入验证码",
          border: false,
          modelValue: _ctx.data.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.code) = $event))
        }, {
          button: _withCtx(() => [
            _createVNode(_component_VanButton, {
              color: "#FFCC32",
              size: "small",
              plain: "",
              onClick: _ctx.sendCode,
              disabled: _ctx.timer != 60
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.timer == 60?'发送验证码':'已发送'+_ctx.timer+'s'), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_VanButton, {
            color: "#FFCC32",
            size: "small",
            block: "",
            onClick: _ctx.bind
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}